import ReportWellness from "../../components/report/report-wellness";
import { ReportWellnessData } from "../../models/interfaces/reports/report-wellness-data";
import { useAuthState } from "../../utilities/contexts/auth-state-context";
import { Redirect } from 'react-router-dom';
import { ReportAnswer } from "../../models/enumerations/report-answer";

const ReportWellnessTestPage: React.FC = () => {
    const { state } = useAuthState();
    if (!state.claims.superAdmin) {
        return <Redirect push to="/" />;
    }

    const data: ReportWellnessData = {
        // BaseReportData fields:
        groupNames: ["test", "test2", "test3"],
        organizationName: "Org Name that can be Longer",
        reportDate: "2022-05-06",
        tagNames: ["FMS Instructors"],
        filterNames: [],
        totalUsers: 20,
        // ReportWellnessData fields:
        mskScoreSecondsCreated: 1748523058,
        behavioralHealth: { average: 89, percentage: 100 },
        movementHealth: {
            percentage: 85,
            average: 80,
            toeTouchReachLeft: { itemOne: false, itemTwo: false },
            toeTouchReachRight: { itemOne: false, itemTwo: false },
            toeTouchQPain: ReportAnswer.A,
            toeTouchScore: 0,
            shoulderMobilityReachLeft: { itemOne: false, itemTwo: false },
            shoulderMobilityReachRight: { itemOne: false, itemTwo: false },
            shoulderMobilityQPain: ReportAnswer.B,
            shoulderMobilityScore: 4,
            rotationReachLeft: { itemOne: false, itemTwo: false },
            rotationReachRight: { itemOne: false, itemTwo: false },
            rotationQPain: ReportAnswer.A,
            rotationScore: 5,
            squatLow: { itemOne: false, itemTwo: false },
            squatQPain: ReportAnswer.A,
            squatScore: 5,
            firstBalanceReach: { itemOne: false, itemTwo: false },
            secondBalanceReachLeft: { success: false, attempts: 2 },
            secondBalanceReachRight: { success: false, attempts: 3 },
            thirdBalanceReachLeft: { success: false, attempts: 1 },
            thirdBalanceReachRight: { success: false, attempts: 2 },
            balanceQPain: ReportAnswer.A,
            balanceScore: 5,
            shoulderClearingScore: false,
            shoulderClearingQPain: ReportAnswer.A,
            spineClearingScore: false,
            spineClearingQPain: ReportAnswer.A
        },
        injuryHistory: {
            percentage: 90,
            average: 85,
            injuryHistoryInjury: true,
            injuryHistoryPain: false,
            injuryHistoryPainPhysician: false,
            injuryHistorySaneScore: 95,
            injuryHistoryPainAreas: "shoulder, ankle"
        },
        sleepWellness: {
            percentage: 80,
            average: 75,
            sleepPSQI: ReportAnswer.B
        },
        nutritionalAwareness: {
            percentage: 70,
            average: 65
        },
        bodyComposition: {
            percentage: 20,
            average: 87,
            bmi: ReportAnswer.B,
            hipToWaistRatio: ReportAnswer.C
        },
        breathingQuality: {
            percentage: 92,
            average: 90,
            breathBreath: ReportAnswer.A,
            breathingQuestionnaire: ReportAnswer.B,
            breathingSmokeNow: false
        },
        physicalActivity: {
            percentage: 85,
            average: 80,
            physicalActivityModerate: ReportAnswer.C,
            physicalActivityVigorous: ReportAnswer.B,
            physicaActivityStrengthNum: ReportAnswer.A
        },
        focusAreas: ["mobility", "strength"],
        movementFocusArea: "mobility",
        readableMovementFocusArea: "Mobility",
        movementFocusAreaDuration: 6,
        roadToWellnessFocusArea: true,
        painCorrective: false,
        ageRange: "25-34",
        age: 28,
        highRiskType: "none",
        highRisk: false,
        symmioAccess: true,
        isFemale: false,
        wellnessScore: 92,
        userFullName: "Test User",
        userEmail: "user@test.com",
        accountHolderEmail: "test@test.com",
        movementPain: false,
        graphLabels: ["Jan", "Feb", "Mar", "Apr"],
        wellnessGraphData: { data: [90, 91, 92, 93], title: "Wellness Score" },
        movementHealthGraphData: { data: [80, 82, 85, 87], title: "Movement Health" },
        physicalActivityGraphData: { data: [120, 130, 140, 150], title: "Physical Activity" },
        bodyCompositionGraphData: { data: [22, 21.5, 22.2, 22.5], title: "Body Composition" },
        injuryHistoryGraphData: { data: [0, 1, 0, 0], title: "Injury History" },
        nutritionAwarenessGraphData: { data: [75, 78, 80, 82], title: "Nutrition Awareness" },
        behavioralHealthGraphData: { data: [85, 87, 89, 90], title: "Behavioral Health" },
        sleepWellnessGraphData: { data: [6, 7, 7.5, 7], title: "Sleep Wellness" },
        breathingQualityGraphData: { data: [88, 89, 90, 91], title: "Breathing Quality" },
        currentMonth: true,
    }

    return <ReportWellness data={data} />;
}

export default ReportWellnessTestPage;
